import { useState } from "react";
import posts from "./posts.json";

const CATEGORY_COLORS = {
  "Stock Analysis": { bg:"rgba(0,200,150,0.1)",  color:"#00C896", border:"rgba(0,200,150,0.2)" },
  "Guides":         { bg:"rgba(99,102,241,0.1)", color:"#818CF8", border:"rgba(99,102,241,0.2)" },
  "News":           { bg:"rgba(255,184,48,0.1)", color:"#FFB020", border:"rgba(255,184,48,0.2)" },
};

function formatDate(dateStr) {
  return new Date(dateStr).toLocaleDateString("en-US", { year:"numeric", month:"long", day:"numeric" });
}

// ── BLOG LIST PAGE ────────────────────────────────────────────────────────────
function BlogList({ onPost, onBack }) {
  const sorted = [...posts].sort((a,b) => new Date(b.date) - new Date(a.date));

  return (
    <div style={{ minHeight:"100vh", background:"#070E1C", color:"#E8EAF0" }}>
      {/* Header */}
      <div style={{ borderBottom:"1px solid rgba(255,255,255,0.06)", padding:"0 52px", height:68, display:"flex", alignItems:"center", justifyContent:"space-between", background:"rgba(7,14,28,0.94)", backdropFilter:"blur(24px)", position:"sticky", top:0, zIndex:100 }}>
        <div style={{ display:"flex", alignItems:"center", gap:16 }}>
          <button onClick={onBack} style={{ background:"none", border:"none", color:"#6B7280", cursor:"pointer", fontSize:13, padding:0, fontFamily:"inherit" }}>← IsHalal</button>
          <span style={{ color:"rgba(255,255,255,0.1)" }}>|</span>
          <span style={{ fontFamily:"'Syne',sans-serif", fontWeight:800, fontSize:16 }}>
            <span style={{ color:"#00C896" }}>Is</span>Halal Blog
          </span>
        </div>
      </div>

      <div style={{ maxWidth:860, margin:"0 auto", padding:"56px 24px" }}>
        {/* Title */}
        <div style={{ marginBottom:48, textAlign:"center" }}>
          <div style={{ fontSize:11, fontWeight:700, color:"#00C896", letterSpacing:"0.14em", textTransform:"uppercase", marginBottom:12 }}>HALAL INVESTING INSIGHTS</div>
          <h1 style={{ fontFamily:"'Syne',sans-serif", fontWeight:800, fontSize:"clamp(32px,5vw,52px)", letterSpacing:"-0.03em", marginBottom:14, lineHeight:1.1 }}>
            The IsHalal <span style={{ background:"linear-gradient(135deg,#00C896,#4FFFD4)", WebkitBackgroundClip:"text", WebkitTextFillColor:"transparent" }}>Blog</span>
          </h1>
          <p style={{ fontSize:15, color:"#6B7280", maxWidth:500, margin:"0 auto", lineHeight:1.8 }}>
            Shariah stock analysis, halal investing guides and Islamic finance insights for Muslim investors worldwide.
          </p>
        </div>

        {/* Featured post */}
        {sorted[0] && (
          <div onClick={() => onPost(sorted[0].slug)} style={{ background:"rgba(255,255,255,0.02)", border:"1px solid rgba(255,255,255,0.08)", borderRadius:20, padding:"32px 36px", marginBottom:24, cursor:"pointer", transition:"border-color 0.2s" }}
            onMouseEnter={e => e.currentTarget.style.borderColor="rgba(0,200,150,0.3)"}
            onMouseLeave={e => e.currentTarget.style.borderColor="rgba(255,255,255,0.08)"}>
            <div style={{ display:"flex", alignItems:"center", gap:10, marginBottom:16 }}>
              <span style={{ fontSize:10, fontWeight:700, padding:"3px 10px", borderRadius:20, background:"rgba(0,200,150,0.1)", color:"#00C896", border:"1px solid rgba(0,200,150,0.2)", letterSpacing:"0.08em" }}>LATEST</span>
              <span style={{ fontSize:11, color:"#4B5563" }}>{formatDate(sorted[0].date)}</span>
              <span style={{ fontSize:11, color:"#4B5563" }}>· {sorted[0].readTime}</span>
            </div>
            <div style={{ display:"flex", gap:20, alignItems:"flex-start" }}>
              <span style={{ fontSize:48, lineHeight:1, flexShrink:0 }}>{sorted[0].coverEmoji}</span>
              <div>
                <h2 style={{ fontFamily:"'Syne',sans-serif", fontWeight:800, fontSize:"clamp(20px,3vw,28px)", letterSpacing:"-0.02em", marginBottom:10, lineHeight:1.2 }}>{sorted[0].title}</h2>
                <p style={{ fontSize:14, color:"#9CA3AF", lineHeight:1.8, marginBottom:12 }}>{sorted[0].excerpt}</p>
                <span style={{ fontSize:12, color:"#00C896", fontWeight:600 }}>Read more →</span>
              </div>
            </div>
          </div>
        )}

        {/* Post grid */}
        <div style={{ display:"grid", gridTemplateColumns:"repeat(auto-fill,minmax(360px,1fr))", gap:16 }}>
          {sorted.slice(1).map(post => {
            const cat = CATEGORY_COLORS[post.category] || CATEGORY_COLORS["Guides"];
            return (
              <div key={post.id} onClick={() => onPost(post.slug)}
                style={{ background:"rgba(255,255,255,0.02)", border:"1px solid rgba(255,255,255,0.07)", borderRadius:16, padding:"24px", cursor:"pointer", transition:"border-color 0.2s" }}
                onMouseEnter={e => e.currentTarget.style.borderColor="rgba(0,200,150,0.25)"}
                onMouseLeave={e => e.currentTarget.style.borderColor="rgba(255,255,255,0.07)"}>
                <div style={{ display:"flex", justifyContent:"space-between", alignItems:"flex-start", marginBottom:14 }}>
                  <span style={{ fontSize:32 }}>{post.coverEmoji}</span>
                  <span style={{ fontSize:10, fontWeight:700, padding:"2px 9px", borderRadius:20, background:cat.bg, color:cat.color, border:`1px solid ${cat.border}` }}>{post.category}</span>
                </div>
                <h3 style={{ fontFamily:"'Syne',sans-serif", fontWeight:700, fontSize:16, letterSpacing:"-0.01em", marginBottom:8, lineHeight:1.35 }}>{post.title}</h3>
                <p style={{ fontSize:13, color:"#6B7280", lineHeight:1.7, marginBottom:14 }}>{post.excerpt}</p>
                <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center" }}>
                  <span style={{ fontSize:11, color:"#374151" }}>{formatDate(post.date)}</span>
                  <span style={{ fontSize:11, color:"#374151" }}>{post.readTime}</span>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
}

// ── BLOG POST PAGE ────────────────────────────────────────────────────────────
function BlogPost({ slug, onBack, onScreen }) {
  const post = posts.find(p => p.slug === slug);
  if (!post) return <div style={{ padding:40, color:"#E8EAF0" }}>Post not found.</div>;

  return (
    <div style={{ minHeight:"100vh", background:"#070E1C", color:"#E8EAF0" }}>
      {/* Header */}
      <div style={{ borderBottom:"1px solid rgba(255,255,255,0.06)", padding:"0 52px", height:68, display:"flex", alignItems:"center", justifyContent:"space-between", background:"rgba(7,14,28,0.94)", backdropFilter:"blur(24px)", position:"sticky", top:0, zIndex:100 }}>
        <div style={{ display:"flex", alignItems:"center", gap:16 }}>
          <button onClick={onBack} style={{ background:"none", border:"none", color:"#6B7280", cursor:"pointer", fontSize:13, padding:0, fontFamily:"inherit" }}>← Blog</button>
          <span style={{ color:"rgba(255,255,255,0.1)" }}>|</span>
          <span style={{ fontFamily:"'Syne',sans-serif", fontWeight:800, fontSize:16 }}>
            <span style={{ color:"#00C896" }}>Is</span>Halal Blog
          </span>
        </div>
      </div>

      <div style={{ maxWidth:720, margin:"0 auto", padding:"56px 24px 80px" }}>
        {/* Meta */}
        <div style={{ display:"flex", alignItems:"center", gap:10, marginBottom:20, flexWrap:"wrap" }}>
          {(() => { const cat = CATEGORY_COLORS[post.category] || CATEGORY_COLORS["Guides"]; return (
            <span style={{ fontSize:10, fontWeight:700, padding:"3px 10px", borderRadius:20, background:cat.bg, color:cat.color, border:`1px solid ${cat.border}` }}>{post.category}</span>
          );})()}
          <span style={{ fontSize:12, color:"#4B5563" }}>{formatDate(post.date)}</span>
          <span style={{ fontSize:12, color:"#4B5563" }}>· {post.readTime}</span>
        </div>

        {/* Title */}
        <div style={{ fontSize:48, marginBottom:16 }}>{post.coverEmoji}</div>
        <h1 style={{ fontFamily:"'Syne',sans-serif", fontWeight:800, fontSize:"clamp(24px,4vw,40px)", letterSpacing:"-0.03em", marginBottom:20, lineHeight:1.15 }}>{post.title}</h1>
        <p style={{ fontSize:16, color:"#9CA3AF", lineHeight:1.9, marginBottom:40, borderBottom:"1px solid rgba(255,255,255,0.06)", paddingBottom:32 }}>{post.excerpt}</p>

        {/* Content blocks */}
        {post.content.map((block, i) => {
          if (block.type === "paragraph") return (
            <p key={i} style={{ fontSize:15, color:"#C8CDD8", lineHeight:1.95, marginBottom:24 }}>{block.text}</p>
          );

          if (block.type === "heading") return (
            <h2 key={i} style={{ fontFamily:"'Syne',sans-serif", fontWeight:700, fontSize:22, letterSpacing:"-0.02em", marginTop:36, marginBottom:14, color:"#E8EAF0" }}>{block.text}</h2>
          );

          if (block.type === "verdict") return (
            <div key={i} style={{ background: block.result==="PASS" ? "rgba(0,200,150,0.06)" : "rgba(255,77,109,0.06)", border:`1px solid ${block.result==="PASS"?"rgba(0,200,150,0.2)":"rgba(255,77,109,0.2)"}`, borderRadius:12, padding:"16px 20px", marginBottom:24, display:"flex", alignItems:"center", gap:14 }}>
              <span style={{ fontSize:24 }}>{block.result==="PASS" ? "✅" : "❌"}</span>
              <div>
                <div style={{ fontSize:12, color:"#6B7280", marginBottom:3 }}>{block.label}</div>
                <div style={{ fontSize:14, fontWeight:700, color: block.result==="PASS" ? "#00C896" : "#FF4D6D" }}>{block.result} — {block.detail}</div>
              </div>
            </div>
          );

          if (block.type === "ratios") return (
            <div key={i} style={{ background:"rgba(255,255,255,0.02)", border:"1px solid rgba(255,255,255,0.07)", borderRadius:14, overflow:"hidden", marginBottom:24 }}>
              {block.items.map((ratio, j) => (
                <div key={j} style={{ display:"flex", justifyContent:"space-between", alignItems:"center", padding:"12px 18px", borderBottom: j < block.items.length-1 ? "1px solid rgba(255,255,255,0.05)" : "none" }}>
                  <div>
                    <div style={{ fontSize:13, color:"#C8CDD8", fontWeight:500 }}>{ratio.label}</div>
                    <div style={{ fontSize:11, color:"#4B5563" }}>Threshold: {ratio.threshold}</div>
                  </div>
                  <span style={{ fontSize:11, fontWeight:700, padding:"3px 10px", borderRadius:20, background: ratio.result==="PASS"?"rgba(0,200,150,0.1)":"rgba(255,77,109,0.1)", color: ratio.result==="PASS"?"#00C896":"#FF4D6D", border:`1px solid ${ratio.result==="PASS"?"rgba(0,200,150,0.2)":"rgba(255,77,109,0.2)"}` }}>✓ {ratio.result}</span>
                </div>
              ))}
            </div>
          );

          if (block.type === "stockList") return (
            <div key={i} style={{ background:"rgba(255,255,255,0.02)", border:"1px solid rgba(255,255,255,0.07)", borderRadius:14, overflow:"hidden", marginBottom:24 }}>
              {block.items.map((stock, j) => (
                <div key={j} style={{ display:"flex", justifyContent:"space-between", alignItems:"center", padding:"12px 18px", borderBottom: j < block.items.length-1 ? "1px solid rgba(255,255,255,0.05)" : "none" }}>
                  <div style={{ display:"flex", alignItems:"center", gap:12 }}>
                    <span style={{ fontFamily:"'Syne',sans-serif", fontWeight:700, color:"#00C896", fontSize:14, minWidth:60 }}>{stock.ticker}</span>
                    <div>
                      <div style={{ fontSize:13, color:"#C8CDD8" }}>{stock.name}</div>
                      <div style={{ fontSize:11, color:"#4B5563" }}>{stock.reason}</div>
                    </div>
                  </div>
                  <button onClick={() => onScreen(stock.ticker)} style={{ fontSize:11, color:"#00C896", background:"rgba(0,200,150,0.08)", border:"1px solid rgba(0,200,150,0.2)", borderRadius:8, padding:"4px 10px", cursor:"pointer", fontFamily:"inherit" }}>Screen →</button>
                </div>
              ))}
            </div>
          );

          if (block.type === "finalVerdict") return (
            <div key={i} style={{ background: block.verdict==="HALAL"?"rgba(0,200,150,0.08)":block.verdict==="HARAM"?"rgba(255,77,109,0.08)":"rgba(255,184,48,0.08)", border:`1px solid ${block.verdict==="HALAL"?"rgba(0,200,150,0.25)":block.verdict==="HARAM"?"rgba(255,77,109,0.25)":"rgba(255,184,48,0.25)"}`, borderRadius:16, padding:"24px 28px", marginBottom:24, textAlign:"center" }}>
              <div style={{ fontSize:32, marginBottom:8 }}>{block.verdict==="HALAL"?"✅":block.verdict==="HARAM"?"❌":"⚠️"}</div>
              <div style={{ fontFamily:"'Syne',sans-serif", fontWeight:800, fontSize:24, color: block.verdict==="HALAL"?"#00C896":block.verdict==="HARAM"?"#FF4D6D":"#FFB020", marginBottom:8 }}>{block.verdict}</div>
              <div style={{ fontSize:14, color:"#9CA3AF" }}>{block.text}</div>
            </div>
          );

          if (block.type === "cta") return (
            <div key={i} style={{ textAlign:"center", marginTop:40, padding:"28px", background:"rgba(0,200,150,0.04)", border:"1px solid rgba(0,200,150,0.15)", borderRadius:16 }}>
              <p style={{ fontSize:14, color:"#6B7280", marginBottom:14 }}>Want to verify this yourself?</p>
              <button onClick={() => onScreen(block.ticker)} style={{ background:"linear-gradient(135deg,#00C896,#007A5E)", border:"none", color:"#fff", padding:"12px 28px", borderRadius:12, fontSize:14, fontWeight:700, cursor:"pointer", fontFamily:"inherit" }}>{block.text} →</button>
            </div>
          );

          return null;
        })}
      </div>
    </div>
  );
}

// ── MAIN EXPORT ───────────────────────────────────────────────────────────────
export default function BlogPage({ onBack, onScreen, initialSlug }) {
  const [currentSlug, setCurrentSlug] = useState(initialSlug || null);

  if (currentSlug) {
    return <BlogPost slug={currentSlug} onBack={() => setCurrentSlug(null)} onScreen={onScreen} />;
  }
  return <BlogList onPost={setCurrentSlug} onBack={onBack} />;
}
